export default __webpack_public_path__ + "static/media/mf.512a2a76.jpg";